"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SvgDoorLockControl = function SvgDoorLockControl(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", null, '.door_lock_control_svg__cls-1{fill:#333}')), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.39 13h-1.57a3 3 0 100 2h1.57v2h2v-2h2v-2h-4zM10 15a1 1 0 111-1 1 1 0 01-1 1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.12 3.89A3 3 0 0020 3H9.68a3 3 0 00-2.14.89l-5.65 5.9A3 3 0 001 11.93V18a3 3 0 003 3h16a3 3 0 003-3V6a3 3 0 00-.88-2.11zM9 5.29A1 1 0 019.68 5H20a1 1 0 01.72.3A1 1 0 0121 6v2H6.39zM20 19H4a1 1 0 01-1-1v-6.07a1 1 0 01.32-.74L4.47 10H21v8a1 1 0 01-1 1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};

var _default = SvgDoorLockControl;
exports["default"] = _default;